<template>
  <el-card class="card-wrap" shadow="hover">
    <div class="flex-c">
      <img src="../../../../assets/image/noList.png" alt="">
      <p>暂无该活动内容</p>
    </div>
  </el-card>
</template>
<script>
export default {
  name: 'noData',
}
</script>
<style lang="less" scoped>
  .card-wrap {
    margin-top: 10px;
    height: 242px;
    .flex-c {
      height: 242px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        width: 72px;
        height: 66px;
      }
      p {
        font-size: 12px;
        color: #999999;
      }
    }
  }
</style>